/* eslint-disable */
export default {
  account: 'Account',
  contact: 'Contatto',
  lead: 'Potenziale cliente',
  opportunity: 'Opportunità',
  case: 'Caso',
  chooseEntity: 'Seleziona il tipo di entità',
  create: 'Crea',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
